import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { BookingSelectors } from '@redux/BookingRedux';
import { FREQUENCIES } from '@services/minte';

import ServiceTypeSingle from './ServiceTypeSingle';
import ServiceTypeRecurring from './ServiceTypeRecurring';

function ServiceType(props) {
  const { selectedFrequency, onSubmit } = props;

  if (selectedFrequency === FREQUENCIES.REGULARLY) {
    return <ServiceTypeRecurring onSubmit={onSubmit} />;
  }

  return <ServiceTypeSingle onSubmit={onSubmit} />;
}

ServiceType.propTypes = {
  selectedFrequency: PropTypes.string,
  onSubmit: PropTypes.func.isRequired
};

const mapStatesToProps = state => ({
  selectedFrequency: BookingSelectors.selectFrequency(state)
});

export default connect(mapStatesToProps)(ServiceType);
